"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var MouseEvent = require("../generated/MouseEvent");

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var NODE_TYPE = require("../node-type");

var _require2 = require("../helpers/form-controls"),
    isLabelable = _require2.isLabelable,
    isDisabled = _require2.isDisabled;

var _require3 = require("../helpers/events"),
    fireAnEvent = _require3.fireAnEvent;

function sendClickToAssociatedNode(node) {
  fireAnEvent("click", node, MouseEvent, {
    bubbles: true,
    cancelable: true,
    view: node.ownerDocument ? node.ownerDocument.defaultView : null,
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    button: 0,
    detail: 1,
    relatedTarget: null
  });
}

var HTMLLabelElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLLabelElementImpl, _HTMLElementImpl);

  function HTMLLabelElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLLabelElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLLabelElementImpl).call(this, args, privateData));
    _this._hasActivationBehavior = true;
    return _this;
  }

  _createClass(HTMLLabelElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      var node = this.control;

      if (node && !isDisabled(node)) {
        sendClickToAssociatedNode(node);
      }
    }
  }, {
    key: "control",
    get: function get() {
      if (this.hasAttributeNS(null, "for")) {
        var forValue = this.getAttributeNS(null, "for");

        if (forValue === "") {
          return null;
        }

        var root = this.getRootNode({});
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = domSymbolTree.treeIterator(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var descendant = _step.value;

            if (descendant.nodeType === NODE_TYPE.ELEMENT_NODE && descendant.getAttributeNS(null, "id") === forValue) {
              return isLabelable(descendant) ? descendant : null;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return null;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = domSymbolTree.treeIterator(this)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _descendant = _step2.value;

          if (isLabelable(_descendant)) {
            return _descendant;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    }
  }, {
    key: "form",
    get: function get() {
      var node = this.control;

      if (node) {
        return node.form;
      }

      return null;
    }
  }]);

  return HTMLLabelElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLLabelElementImpl
};